module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-03-ea15e0b39c152fe2e2479be1540f1c1f.png";